import { createAsyncThunk } from "@reduxjs/toolkit";
import { TServiceError } from "types/general";
import { toastMessage } from "components/ToastMessage";
import {
  IPortfolioSelection,
  getPortfolioSelection,
} from "api/getPortfolioSelection";
import {
  IPortfolioSubjectSelection,
  updatePortfolioSelection,
} from "api/updatePortfolioSelection";
import {
  IPortfolioDashboard,
  getPortfolioDashboard,
} from "api/getPortfolioDashboard";
import { PORTFOLIO_SLICE_NAME } from "./constants";

export const fetchPortfolioSelection = createAsyncThunk<
  IPortfolioSelection,
  void,
  { rejectValue: TServiceError }
>(
  `${PORTFOLIO_SLICE_NAME}/fetchPortfolioSelection`,
  async (_, { rejectWithValue }) => {
    try {
      return await getPortfolioSelection();
    } catch (err) {
      toastMessage({
        message: "Failed to load the portfolio selection. Please try again.",
        type: "error",
        position: "top-right",
      });

      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);

export const fetchPortfolioDashboard = createAsyncThunk<
  IPortfolioDashboard,
  void,
  { rejectValue: TServiceError }
>(
  `${PORTFOLIO_SLICE_NAME}/fetchPortfolioDashboard`,
  async (_, { rejectWithValue }) => {
    try {
      return await getPortfolioDashboard();
    } catch (err) {
      toastMessage({
        message: "Failed to load the portfolio dashboard. Please try again.",
        type: "error",
        position: "top-right",
      });

      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);

export const savePortfolioSelection = createAsyncThunk<
  IPortfolioSelection,
  IPortfolioSubjectSelection[],
  { rejectValue: TServiceError }
>(
  `${PORTFOLIO_SLICE_NAME}/savePortfolioSelection`,
  async (subjects, { rejectWithValue }) => {
    try {
      return await updatePortfolioSelection(subjects);
    } catch (err) {
      toastMessage({
        message: "Failed to save the portfolio selection. Please try again.",
        type: "error",
        position: "top-right",
      });

      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);
